(ns portal.third-party-credentials.ocp
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/InputAdornment$default" :as InputAdornment]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Select$default" :as Select]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["react-hook-form" :as rhf]
            ["src/svg/organisations/other/facebook.svg$default" :as Facebook]
            ["src/svg/organisations/other/instagram.svg$default" :as Instagram]
            ["src/svg/organisations/other/meta.svg$default" :as Meta]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.set :as set]
            [clojure.string :as str]
            [common.flags :refer [use-flag]]
            [common.form :as form]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.cm360-settings :as cm360.q]
            [common.resource.query.social-settings :as social-settings.q]
            [common.widgets.form-field :refer [form-field]]
            [manage.adset-decision-tree-page.view.common :refer [id-input]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn prepare-form-data [data]
  (let [wrap-strings #(mapv (fn [s] {:value s}) %)]
    (-> data
        (set/rename-keys {:id :meta-ad-account-id})
        (update :meta-page-ids wrap-strings)
        (update :meta-instagram-user-ids wrap-strings)
        ->js)))

(defn prepare-submit-data [data]
  (let [get-strings #(vec (keep (fn [{:keys [value]}]
                                  (when-not (str/blank? value)
                                    value))
                                %))]
    (-> (->clj data)
        (update :meta-page-ids get-strings)
        (update :meta-instagram-user-ids get-strings))))

(defn handle-backend-errors
  [setError getValues {:keys [invalid-ad-account-id
                              invalid-page-ids
                              invalid-instagram-user-ids
                              usages]}]
  (if (seq usages)
    (rf/dispatch [:modal/open {:id :social-credentials/ids-used-modal
                               :props {:usages usages :is-change true}}])
    (let [{:keys [meta-page-ids meta-instagram-user-ids]} (->clj (getValues))
          invalid-page-ids-set (set invalid-page-ids)
          invalid-instagram-user-ids-set (set invalid-instagram-user-ids)]
      (when (seq invalid-ad-account-id)
        (setError "meta-ad-account-id" #js {:type "validate"
                                            :message "Invalid Meta Ad account ID"}))
      (doseq [[idx {:keys [value]}] (map-indexed vector meta-page-ids)]
        (when (invalid-page-ids-set value)
          (setError (str "meta-page-ids." idx ".value")
                    #js {:type "validate"
                         :message "Invalid Facebook page ID"})))
      (doseq [[idx {:keys [value]}] (map-indexed vector meta-instagram-user-ids)]
        (when (invalid-instagram-user-ids-set value)
          (setError (str "meta-instagram-user-ids." idx ".value")
                    #js {:type "validate"
                         :message "Invalid Instagram user ID"}))))))

(defui id-field
  [{:keys [field-name label icon required label-action placeholder]}]
  ($ form-field {:label label
                 :required? required
                 :label-action label-action}
     ($ form/form-text-field
        {:name field-name
         :rules (when required
                  #js {:required #js {:value true
                                      :message (str label " is required")}})
         :field-props {:fullWidth true
                       :placeholder (or placeholder (str "Paste your " label " here"))
                       :InputProps {:startAdornment ($ InputAdornment {:position "start"}
                                                       ($ SvgIcon {:component icon}))}}})))

(defui ids-field-array [{:keys [field-array-name label required icon placeholder]}]
  (let [{:keys [fields append remove]} (form/use-field-array #js {:name field-array-name})]
    ($ Stack {:spacing 1}
       (map-indexed
        (fn [index field]
          ($ id-field
             {:key (.-id field)
              :label label
              :required (and required (= index 0))
              :field-name (str field-array-name "." index ".value")
              :icon icon
              :placeholder placeholder
              :label-action ($ IconButton
                               {:size "small"
                                :onClick #(remove index)
                                :color "error"
                                :sx #js {:ml "auto"
                                         :visibility (when (<= (count fields) 1) "hidden")}}
                               ($ Icon "delete_outline"))}))
        (or (seq fields) [#js {:id (str "default." field-array-name)}]))
       ($ Button {:startIcon ($ Icon "add")
                  :onClick #(append #js {:value ""})
                  :sx #js {:alignSelf "flex-end"}
                  :color "text.subtle"}
          "Add"))))

(defui type-selector [{:keys [value on-change]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {existing-cm360 :data} (use-query (cm360.q/cm360-account-query advertiser-id))]
    ($ form-field {:label "Credential type" :required? true}
       ($ Select {:value (if value (name value) "")
                  :onChange (fn [^js e] (when on-change
                                          (on-change (keyword (.. e -target -value)))))
                  :disabled (nil? on-change)
                  :size "small"
                  :fullWidth true
                  :displayEmpty true}
          ($ MenuItem {:value "" :disabled true} "Select type")
          ($ MenuItem {:value "meta"} "Meta")
          ($ MenuItem {:value "cm360" :disabled (some? existing-cm360)} "CM360")))))

(defui meta-form-body []
  ($ Stack {:gap 3}
     ($ form-field {:label "Name" :required? true}
        ($ form/form-text-field {:name "description"
                                 :rules #js {:required #js {:value true
                                                            :message "Name is required"}}
                                 :field-props {:fullWidth true
                                               :placeholder "Name your configuration"}}))
     ($ id-field {:label "Meta Ad account"
                  :required true
                  :field-name "meta-ad-account-id"
                  :icon Meta})
     ($ ids-field-array {:field-array-name "meta-page-ids"
                         :label "Facebook page ID"
                         :required true
                         :icon Facebook})
     ($ Divider)
     ($ ids-field-array {:field-array-name "meta-instagram-user-ids"
                         :label "Instagram user ID"
                         :icon Instagram
                         :placeholder "Enter ID to activate on Instagram"})))

(defui cm360-form-body [{:keys [advertiser-id]}]
  (let [cc-account-id (rhf/useWatch #js {:name "cc-account-id"})
        profile-id (rhf/useWatch #js {:name "cm360-profile-id"})
        {assets :data assets-loading :isLoading}
        (use-query (cm360.q/assets-query advertiser-id))
        {profiles :data profiles-loading :isLoading}
        (use-query (cm360.q/cm360-profiles-query advertiser-id cc-account-id))
        {cm360-advertisers :data advertisers-loading :isLoading}
        (use-query (cm360.q/cm360-advertisers-query advertiser-id cc-account-id profile-id))]
    ($ Stack {:spacing 3}
       ($ id-input {:name "cc-account-id"
                    :label "CC Asset"
                    :required true
                    :loading assets-loading
                    :ids-with-description assets})
       (when cc-account-id
         ($ id-input {:name "cm360-profile-id"
                      :label "CM360 Profile"
                      :required true
                      :loading profiles-loading
                      :no-options-text "No profiles found"
                      :ids-with-description profiles}))
       (when profile-id
         ($ id-input {:name "cm360-advertiser-id"
                      :label "CM360 Advertiser"
                      :required true
                      :loading advertisers-loading
                      :no-options-text "No advertisers found"
                      :ids-with-description cm360-advertisers})))))

(defocp ocp-view :social/config
  [{:keys [type account] :as existing}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        cm360-enabled? (use-flag :decision-tree-generate-external-trackers)
        [type-state set-type] (uix/use-state (or type nil))
        effective-type (if cm360-enabled? type-state :meta)
        {:keys [handleSubmit setError getValues] :as form}
        (form/use-form #js {:values (case type
                                      :meta (prepare-form-data existing)
                                      :cm360 (if account (-> account clj->js) #js {})
                                      #js {})
                            :resetOptions #js {:keepDirtyValues true}})
        {upsert-meta :mutate}
        (use-mutation (social-settings.q/upsert-social-settings-mutation
                       advertiser-id
                       (partial handle-backend-errors setError getValues)))
        {upsert-cm360 :mutate}
        (use-mutation (cm360.q/upsert-cm360-account-mutation advertiser-id))
        on-submit (handleSubmit
                   (fn [^js values]
                     (case effective-type
                       :meta (upsert-meta (prepare-submit-data values))
                       :cm360 (upsert-cm360 (->clj values))
                       nil)))
        title (case effective-type
                :meta (if (= type :meta) "Edit Meta configuration" "New Meta configuration")
                :cm360 (if account "Edit CM360 configuration" "New CM360 configuration")
                "Add configuration")
        footer (when effective-type
                 ($ Button {:variant "contained" :onClick on-submit}
                    "Save configuration"))]
    ($ ocp {:title title :footer footer}
       ($ rhf/FormProvider (->js form)
          (when cm360-enabled?
            ($ type-selector {:value type-state
                              :on-change (when-not type set-type)}))
          (case effective-type
            :meta ($ meta-form-body)
            :cm360 ($ cm360-form-body {:advertiser-id advertiser-id})
            nil)))))
